var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7DF1E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h50v50H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,41.8l3.8-2.3c0.7,1.3,1.4,2.4,3,2.4c1.5,0,2.5-0.6,2.5-3V23h4.7v16c0,4.9-2.9,7.1-7,7.1 C16.4,46.1,14.3,44.1,13.1,41.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,41.3l3.8-2.2c1,1.6,2.3,2.9,4.6,2.9c1.9,0,3.2-1,3.2-2.3c0-1.6-1.3-2.2-3.4-3.1L36.8,36c-3.4-1.4-5.6-3.3-5.6-7.1 c0-3.5,2.7-6.2,6.9-6.2c3,0,5.1,1,6.7,3.8l-3.7,2.3c-0.8-1.4-1.7-2-3-2c-1.4,0-2.2,0.9-2.2,2c0,1.4,0.9,2,2.9,2.9l1.2,0.5 c4,1.7,6.2,3.5,6.2,7.4c0,4.2-3.3,6.5-7.8,6.5C34,46.1,31.1,44,29.8,41.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.273d02ae3219b23539b2145fcadbf518.svg";
export { ForwardRef as ReactComponent };